// src/AddHorse.js
import React, { useState, useEffect } from "react";
import { db, auth, storage } from "./firebase"; // 👈 make sure storage is exported
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { onAuthStateChanged } from "firebase/auth";

export default function AddHorse() {
  const [ownername, setOwnername] = useState("");
  const [contact, setContact] = useState("");
  const [horseName, setHorseName] = useState("");
  const [horseAge, setHorseAge] = useState("");
  const [horseBreed, setHorseBreed] = useState("");
  const [description, setDescription] = useState("");
  const [imageFile, setImageFile] = useState(null); // 👈 instead of URL
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [user, setUser] = useState(null);

  // 🔑 Listen for auth changes
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });
    return () => unsubscribe();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!user) {
      setMessage("❌ You must be logged in to add a horse.");
      return;
    }

    if (!imageFile) {
      setMessage("❌ Please upload an image.");
      return;
    }

    setLoading(true);
    setMessage("");

    try {
      // 🔼 Upload image to Firebase Storage
      const storageRef = ref(storage, `horses/${user.uid}/${Date.now()}_${imageFile.name}`);
      await uploadBytes(storageRef, imageFile);
      const downloadURL = await getDownloadURL(storageRef);

      // 🐎 Save horse to Firestore
      await addDoc(collection(db, "horses"), {
        ownername: ownername,
        contact: contact,
        name: horseName,
        age: horseAge,
        breed: horseBreed,
        description: description,
        imageUrl: downloadURL, // 👈 use Storage URL
        owner: user.uid,
        createdAt: serverTimestamp(),
      });

      setMessage("✅ Horse saved successfully!");
      setOwnername("");
      setContact("");
      setHorseName("");
      setHorseAge("");
      setHorseBreed("");
      setDescription("");
      setImageFile(null);
    } catch (error) {
      console.error("Error saving horse:", error);
      setMessage("❌ Failed to save horse.");
    } finally {
      setLoading(false);
    }
  };

  // 🔒 If not logged in, show a message instead of the form
  if (!user) {
    return (
      <div style={{ maxWidth: "500px", margin: "2rem auto", textAlign: "center" }}>
        <h2>Add a Horse</h2>
        <p style={{ color: "red" }}>🚫 You must be logged in to add a horse.</p>
      </div>
    );
  }

  return (
    <div
      style={{
        maxWidth: "500px",
        margin: "2rem auto",
        padding: "2rem",
        background: "rgba(16, 167, 255, 0.9)",
        borderRadius: "12px",
        boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
      }}
    >
      <h2 style={{ textAlign: "center", marginBottom: "1rem" }}>Add a Horse</h2>

      <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
        <input
          type="text"
          placeholder="Owner Name"
          value={ownername}
          onChange={(e) => setOwnername(e.target.value)}
          required
          style={inputStyle}
        />

        <input
          type="text"
          placeholder="Contact"
          value={contact}
          onChange={(e) => setContact(e.target.value)}
          required
          style={inputStyle}
        />
        
        <input
          type="text"
          placeholder="Horse Name"
          value={horseName}
          onChange={(e) => setHorseName(e.target.value)}
          required
          style={inputStyle}
        />

        <input
          type="number"
          placeholder="Age"
          value={horseAge}
          onChange={(e) => setHorseAge(e.target.value)}
          required
          style={inputStyle}
        />

        <input
          type="text"
          placeholder="Breed"
          value={horseBreed}
          onChange={(e) => setHorseBreed(e.target.value)}
          required
          style={inputStyle}
        />

        <input
          type="text"
          placeholder="Description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          required
          style={inputStyle}
        />

        <p>Upload Picture</p>

        {/* 📂 File upload instead of URL */}
        <input
          type="file"
          accept="image/*"
          onChange={(e) => setImageFile(e.target.files[0])}
          required
          style={inputStyle}
        />

        <button
          type="submit"
          disabled={loading}
          style={{
            padding: "0.75rem",
            background: "#4CAF50",
            color: "white",
            fontSize: "1rem",
            fontWeight: "bold",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
            transition: "0.3s",
          }}
        >
          {loading ? "Saving..." : "Save Horse"}
        </button>
      </form>

      {message && <p style={{ marginTop: "1rem", textAlign: "center" }}>{message}</p>}
    </div>
  );
}

// simple input style (reusable)
const inputStyle = {
  padding: "0.75rem",
  fontSize: "1rem",
  borderRadius: "6px",
  border: "1px solid #ccc",
  outline: "none",
};
